// extracted by mini-css-extract-plugin
export default {"amountInput":"wZEKc","prefix":"NBsRj"};